module.exports = __webpack_public_path__ + "img/edit.610dad78.svg";